// ฟังก์ชันสำหรับเข้ารหัสและถอดรหัส API key

// ฟังก์ชันสำหรับเข้ารหัส API key
export const encryptApiKey = (apiKey) => {
  if (!apiKey) return '';
  
  try {
    // เข้ารหัสอย่างง่ายด้วย Base64 และเพิ่ม salt
    const salt = 'AI-UNLOCKED-SALT-2024';
    const saltedKey = apiKey + salt;
    const encodedKey = btoa(saltedKey);
    
    // สลับตำแหน่งตัวอักษรเพื่อเพิ่มความปลอดภัย
    return encodedKey.split('').reverse().join('');
  } catch (error) {
    console.error('Error encrypting API key:', error);
    return '';
  }
};

// ฟังก์ชันสำหรับถอดรหัส API key
export const decryptApiKey = (encryptedKey) => {
  if (!encryptedKey) return '';
  
  try {
    // สลับตำแหน่งตัวอักษรกลับ
    const reversedKey = encryptedKey.split('').reverse().join('');
    
    // ถอดรหัส Base64
    const decodedKey = atob(reversedKey);
    
    // ลบ salt ออก
    const salt = 'AI-UNLOCKED-SALT-2024';
    return decodedKey.replace(salt, '');
  } catch (error) {
    console.error('Error decrypting API key:', error);
    return '';
  }
};
